/** How a template references a fill-in's answer. */
export function promptToken(key: string): string {
  return `{{ prompts.${key} }}`
}
